export default __webpack_public_path__ + "static/media/ftj-1.e208eaa0.png";